import React from "react";
import { MessageCircle } from "lucide-react";
import { buildWhatsAppUrl } from "@/lib/brand";
import { trackClick } from "@/lib/analytics";

const DEFAULT_MSG = "Namaste 🙏 I would like to place an order / know more about Sanatan Dharma products.";

const WhatsAppFab = () => {
  return (
    <a
      href={buildWhatsAppUrl(DEFAULT_MSG)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackClick("whatsapp-fab")}
      data-testid="whatsapp-fab"
      aria-label="Order on WhatsApp"
      className="fixed z-40 bottom-6 right-6 sm:bottom-8 sm:right-8 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 group-hover:opacity-70 animate-ping" />
      <span className="relative flex items-center gap-2 bg-[#25D366] hover:bg-[#1EBE57] text-white pl-4 pr-5 py-3.5 rounded-full shadow-xl transition-colors">
        <MessageCircle size={20} />
        <span className="hidden sm:inline text-xs uppercase tracking-[0.16em] font-semibold">Order on WhatsApp</span>
      </span>
    </a>
  );
};

export default WhatsAppFab;
